<template>
  <custom-modal
    ref="contractList"
    @close="loadCounts"
    component-to-open="ContractList"
    extra-class="bg-emerald-400 text-white/90 font-medium fill-white/90"
  >
    <template v-slot:header>
      {{ $t("contracts.contractList") }}
    </template>
    <template v-slot:body>
      <contract-list @close="$refs.contractList.closeModal()" :contracts="filteredContracts"/>
    </template>
  </custom-modal>

  <div class="w-5/6 2xl:w-3/4 flex justify-start mx-auto mt-10 capitalize">
    <div class="w-1/2 grid grid-cols-2 grid-rows-1 gap-6">
      <router-link
        :class="statuses.agreement_signed === 0 ? 'cursor-default' : 'cursor-pointer'"
        :to="statuses.agreement_signed === 0 ? '' : { name: 'contracts', query: { status: 'agreement_signed' }}"
      >
        <base-dashboard-container extra-class="bg-red-50 text-red-500 border-red-500">
          <template v-slot:title>{{ $t('dashboard.signed') }}</template>
          <template v-slot:number> {{ statuses.agreement_signed }} </template>
        </base-dashboard-container>
      </router-link>
      <router-link
        :class="statuses.ready_to_be_shipped === 0 ? 'cursor-default' : 'cursor-pointer'"
        :to="statuses.ready_to_be_shipped === 0 ? '' : { name: 'contracts', query: { status: 'ready_to_be_shipped' }}"
      >
        <base-dashboard-container extra-class="bg-sky-50 text-sky-500 border-sky-500">
          <template v-slot:title>{{ $t('dashboard.ready-to-be-shipped') }}</template>
          <template v-slot:number> {{ statuses.ready_to_be_shipped }} </template>
        </base-dashboard-container>
      </router-link>
    </div>
    <div class="ml-6 w-1/2 grid grid-rows-1 gap-y-6">
      <router-link
        :class="statuses.shipped === 0 ? 'cursor-default' : 'cursor-pointer'"
        :to="statuses.shipped === 0 ? '' : { name: 'contracts', query: { status: 'shipped' }}"
      >
        <base-dashboard-container extra-class="bg-lime-50 text-lime-600 border-lime-600">
          <template v-slot:title>{{ $t('dashboard.shipped') }}</template>
          <template v-slot:number> {{ statuses.shipped }}  </template>
        </base-dashboard-container>
      </router-link>
    </div>
  </div>
  <div class="w-5/6 2xl:w-3/4 flex justify-start mx-auto mt-10 capitalize">
    <div class="w-full grid grid-cols-2 grid-rows-1 gap-6">
      <base-dashboard-container
        extra-class="bg-green-50 text-green-500 border-green-500 cursor-pointer"
        :class="statuses.buy_good_requested === 0 ? 'cursor-default' : 'cursor-pointer'"
        @click="statuses.buy_good_requested > 0 ? openContractsModal('buy_good_requested') : ''"
      >
        <template v-slot:title>{{ $t('dashboard.buy_good_requested') }}</template>
        <template v-slot:number> {{ statuses.buy_good_requested }} </template>
      </base-dashboard-container>
      <base-dashboard-container
        extra-class="bg-red-100 text-red-500 border-red-500 cursor-pointer"
        :class="statuses.stop_rent_requested === 0 ? 'cursor-default' : 'cursor-pointer'"
        @click="statuses.stop_rent_requested > 0 ? openContractsModal('stop_rent_requested') : ''"
      >
        <template v-slot:title>{{ $t('dashboard.stop_rent_requested') }}</template>
        <template v-slot:number> {{ statuses.stop_rent_requested }} </template>
      </base-dashboard-container>
    </div>
  </div>
  <div class="w-5/6 2xl:w-3/4 flex justify-start mx-auto mt-10 capitalize">
    <div class="w-full grid grid-cols-2 grid-rows-1 gap-6">
      <base-dashboard-container
        extra-class="bg-violet-50 text-violet-500 border-violet-500 cursor-pointer"
        :class="outstandingSubscriptions === 0 ? 'cursor-default' : 'cursor-pointer'"
        @click="outstandingSubscriptions > 0 ? openContractsModal('outstanding_subscriptions') : ''"
      >
        <template v-slot:title>{{ $t('dashboard.outstanding_subscriptions') }}</template>
        <template v-slot:number> {{ outstandingSubscriptions }} </template>
      </base-dashboard-container>
      <base-dashboard-container
        extra-class="bg-orange-50 text-orange-500 border-orange-500 cursor-pointer"
        :class="activeBy18Months === 0 ? 'cursor-default' : 'cursor-pointer'"
        @click="activeBy18Months > 0 ? openContractsModal('active_by_18_months') : ''"
      >
        <template v-slot:title>{{ $t('dashboard.active_by_18_month') }}</template>
        <template v-slot:number> {{ activeBy18Months }} </template>
      </base-dashboard-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseDashboardContainer from '@/components/base/BaseDashboardContainer.vue';
import CustomModal from '@/components/base/CustomModal.vue';
import ContractList from '@/components/contracts/ContractList.vue';

export default {
  components: {
    BaseDashboardContainer,
    CustomModal,
    ContractList,
  },
  data() {
    return {
      filteredContracts: [],
      // Only the counts are loaded here: the contracts of a box are fetched when it is opened
      statuses: {
        agreement_signed: 0,
        ready_to_be_shipped: 0,
        shipped: 0,
        buy_good_requested: 0,
        stop_rent_requested: 0,
      },
      outstandingSubscriptions: 0,
      activeBy18Months: 0,
    };
  },
  async created() {
    await this.loadCounts();
  },
  methods: {
    ...mapActions('contracts', ['getDashboardCounts', 'getDashboardContracts']),
    async loadCounts() {
      const counts = await this.getDashboardCounts();
      this.statuses = counts.statuses;
      this.outstandingSubscriptions = counts.outstanding_subscriptions;
      this.activeBy18Months = counts.active_by_18_months;
    },
    async openContractsModal(list) {
      this.filteredContracts = await this.getDashboardContracts(list);
      this.$refs.contractList.openModal();
    },
  },
};
</script>
